import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function ExternalButton({
  to,
  onClick,
  text,
  buttonStyle,
  buttonColor,
  className,
  preview,
  children,
  ...otherProps
}) {
  if ((!to && !onClick) || (!text && !children)) {
    return null;
  }
  if (buttonStyle) {
    buttonStyle = 'btn-' + buttonStyle;
  }
  if (buttonColor) {
    buttonColor = 'button-color-' + buttonColor;
  }
  const setClassName = `btn ${buttonStyle || ''} ${buttonColor || ''} ${
    className || ''
  }`;

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={setClassName}
        type="button"
        {...otherProps}
      >
        {text}
        {children}
      </button>
    );
  } else if (
    preview ||
    to.startsWith('http://') ||
    to.startsWith('https://') ||
    to.startsWith('//') ||
    to.startsWith('mailto:') ||
    to.startsWith('tel:')
  ) {
    return (
      <a
        href={to}
        className={setClassName}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
        {children}
      </a>
    );
  } else if (to.startsWith('/')) {
    return (
      <Link to={to} className={setClassName} {...otherProps}>
        {text}
        {children}
      </Link>
    );
  } else {
    return null;
  }
}

ExternalButton.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
  buttonStyle: PropTypes.oneOf(['success', 'primary', 'default', 'underline']),
  buttonColor: PropTypes.string,
  children: PropTypes.any,
  preview: PropTypes.bool
};

export default ExternalButton;
